import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Docs from '/src/_includes/braintree-note.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Docs mdxType="Docs" />
    <h1 {...{
      "id": "payments-integrations"
    }}>{`Payments Integrations`}</h1>
    <p>{`Adobe Commerce payment provider gateway is a mechanism that allows you to integrate your stores with payment service providers. As a result, you can create and handle transactions based on order details.`}</p>
    <p>{`This guide describes how the Commerce payment provider gateway is implemented and how you can add custom integration with payment providers and add vault payments.`}</p>
    <p>{`The chapters of this guide are:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "payment-gateway/"
          }}>{`Commerce payment provider gateway`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "base-integration/"
          }}>{`How to add a custom payment method using Commerce payment provider gateway`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "vault/"
          }}>{`How to add vault for the custom payment method`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      